<template>
  <div id="register-step1" class="register-step">
    <div id="content-main">
      <div class="register-header register-header-margin">
        <div>
          <a @click="prevStep">
            <span class="icon"> <i class="mdi mdi-arrow-left"></i> </span>
          </a>
        </div>

        <div></div>
      </div>

      <div class="register-content">
        <h2>Soy profesional sanitario</h2>
        <a
          v-for="role in getRegisterConfiguration.data"
          :key="role.rol"
          style="margin-top: 1.5em;"
          class="button is-outlined is-primary is-fullwidth"
          @click="next(role)"
        >
          {{ role.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'
export default {
  name: 'RegisterStep2a',
  mixins: [RegisterStepMixin, ToolsMixin],
  computed: {},
  methods: {
    next(role) {
      this.currentRole = role.rol
      this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 3', 'Next')
    }
  }
}
</script>

<style lang="scss" scoped></style>
